import styled from 'styled-components';

// Carries `canvas-container`, which the timeline resize logic measures.
export const EditorCanvasContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    outline: none;
    -webkit-user-select: none;
    user-select: none;

    canvas {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
